import React, { Component } from "react";
import { Link } from "react-router-dom";
import MedicalConsentHeader from "./MedicalConsentHeader";
import Content from "./../../content/Content";
import Store from "./../../content/Store";
import CheckboxInputGroup from "./../shared/CheckboxInputGroup";
import { isFieldDefined } from "../../validations/RequiredFieldValidator";
import DisplayValidationErrors from "../../components/shared/DisplayValidationErrors";
import InternalViewButton from "../shared/buttons/InternalViewButton";

export default class TermsAndConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      acceptTermsAndConditionsHasError: false
    };
    this.validate = this.validate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event) {
    event.preventDefault();
    let errorMessages = this.validate();
    if (errorMessages.length === 0) {
      this.props.onSubmit(event);
    } else {
      this.setState({
        errors: errorMessages
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  validate() {
    let errors = [];
    let acceptTermsAndConditionsIsDefined = isFieldDefined(
      this.props.medicalConsent.acceptTermsAndConditions
    );

    let hasError =
      !acceptTermsAndConditionsIsDefined ||
      this.props.medicalConsent.acceptTermsAndConditions === "no";

    if (hasError) {
      errors.push(
        Store.MedicalConsent.ValidationErrors.TermsAndConditionsMustBeAccepted
      );
    }

    this.setState({
      acceptTermsAndConditionsHasError: hasError
    });

    return errors;
  }

  render() {
    return (
      <React.Fragment>
        <MedicalConsentHeader
          pageTitle={
            <Content name={Store.MedicalConsent.TermsAndConditionsTitle} />
          }
          pageBody={
            <Content name={Store.MedicalConsent.TermsAndConditionsText} />
          }
        />

        <DisplayValidationErrors
          heading={this.props.errorValidationHeading}
          errors={this.state.errors}
        />

        <form onSubmit={event => this.onSubmit(event)}>
          <CheckboxInputGroup
            hasError={this.state.acceptTermsAndConditionsHasError}
            groupHeader={
              <Content
                name={Store.MedicalConsent.TermsAndConditionsAcceptTsandCsLabel}
              />
            }
            onChange={this.props.onChange}
            groupName="acceptTermsAndConditions"
            inputValue={this.props.medicalConsent.acceptTermsAndConditions}
          />

          <div className="row my-5">
            <div className="col-sm-6 back-button">
              <p className="axa-body-text-4 mt-2">
                <Link
                  id="backButton"
                  to=""
                  onClick={event =>
                    this.props.previousContentHandleBackClick(event)
                  }
                >
                  <span className="mr-2 left-arrow-back">←</span>{" "}
                  {this.props.buttonBackText}
                </Link>
              </p>
            </div>
            <div className="col-sm-6 text-right" id="termsAndConditionSubmit">
              <InternalViewButton label={this.props.submitButton} />
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}
